
<template>
    <div class="gdpr gdpr-container">
        <h3 class="gdpr__title">
            {{ gdpr.name }}
        </h3>
        <div class="gdpr__content" v-html="gdpr.content">
            
        </div>
    </div>
</template>

<script>
    import GlobalService from './../../services/Global'
    export default {
        data () {
            return {
                gdpr: {
                    
                }
            }
        },
        created () {
          this.getPages()  
        },
        watch: {
            $route (to, from) {
                this.getPages()
            }
        },
        methods: {
            getPages () {
                GlobalService.goToTop()
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    this.gdpr = response.data
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            }
        }
    }
</script>